var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".text-danger[data-v-3ee196d9] {\n  color: red;\n  font-size: 0.85rem;\n}\n.not-allowed[data-v-3ee196d9] {\n  cursor: not-allowed;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UserDetails",
  props: ["submitting", "clear_form"],
  data: function data() {
    return {
      userDetails: {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        state: "",
        country: "",
        phoneNumber: "",
        postalCode: ""
      },
      errors: {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        state: "",
        country: "",
        phoneNumber: "",
        postalCode: ""
      }
    };
  },
  mounted: function mounted() {},

  watch: {
    errors: {
      handler: function handler() {
        this.can_pay = (0, _values2.default)(this.errors).every(function (err) {
          return err === "";
        });
      },

      deep: true
    },
    clear_form: function clear_form(newVal) {
      if (newVal === true) {
        this.clearForm();
      }
    }
  },
  computed: {
    can_pay: function can_pay() {
      var allFilled = (0, _values2.default)(this.userDetails).every(function (val) {
        return val && val.toString().trim() !== "";
      });

      var noErrors = (0, _values2.default)(this.errors).every(function (err) {
        return err === "";
      });

      return allFilled && noErrors;
    }
  },
  methods: {
    validateFirstName: function validateFirstName() {
      this.errors.firstName = this.userDetails.firstName ? "" : "First name is required";
    },
    validateLastName: function validateLastName() {
      this.errors.lastName = this.userDetails.lastName ? "" : "Last name is required";
    },
    validateCity: function validateCity() {
      this.errors.city = this.userDetails.city ? "" : "City is required";
    },
    validateState: function validateState() {
      this.errors.state = this.userDetails.state ? "" : "State is required";
    },
    validateCountry: function validateCountry() {
      this.errors.country = this.userDetails.country ? "" : "Country is required";
    },
    validatePhoneNumber: function validatePhoneNumber() {
      this.errors.phoneNumber = this.userDetails.phoneNumber ? "" : "Phone number is required";
    },
    validatePostalCode: function validatePostalCode() {
      this.errors.postalCode = this.userDetails.postalCode ? "" : "Postal code is required";
    },
    validateEmail: function validateEmail() {
      var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.userDetails.email) {
        this.errors.email = "Email is required";
      } else if (!pattern.test(this.userDetails.email)) {
        this.errors.email = "Invalid email";
      } else {
        this.errors.email = "";
      }
    },
    validateField: function validateField(field) {
      switch (field) {
        case "firstName":
          this.validateFirstName();
          break;
        case "lastName":
          this.validateLastName();
          break;
        case "email":
          this.validateEmail();
          break;
        case "city":
          this.validateCity();
          break;
        case "state":
          this.validateState();
          break;
        case "country":
          this.validateCountry();
          break;
        case "phoneNumber":
          this.validatePhoneNumber();
          break;
        case "postalCode":
          this.validatePostalCode();
          break;
      }
    },
    clearForm: function clearForm() {
      this.userDetails = {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        state: "",
        country: "",
        phoneNumber: "",
        postalCode: ""
      };
      this.errors = {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        state: "",
        country: "",
        phoneNumber: "",
        postalCode: ""
      };
      this.can_pay = false;
    },
    validateForm: function validateForm() {
      this.validateFirstName();
      this.validateLastName();
      this.validateEmail();
      this.validateCity();
      this.validateState();
      this.validateCountry();
      this.validatePhoneNumber();
      this.validatePostalCode();

      return (0, _values2.default)(this.errors).every(function (err) {
        return err === "";
      });
    },
    handleSubmit: async function handleSubmit() {
      if (this.validateForm()) {
        this.submitting = true;
        try {
          this.$emit("collecteduserDetails", this.userDetails);
        } finally {
          this.submitting = false;
        }
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"frmCard"}},[_c('div',{staticClass:"card-body",attrs:{"id":"userDetailsForm"}},[_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userDetails.firstName),expression:"userDetails.firstName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"nameCS","placeholder":"First name","required":""},domProps:{"value":(_vm.userDetails.firstName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "firstName", $event.target.value.trim())},function($event){return _vm.validateField('firstName')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.firstName)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.firstName)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userDetails.lastName),expression:"userDetails.lastName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Surname","required":""},domProps:{"value":(_vm.userDetails.lastName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "lastName", $event.target.value.trim())},function($event){return _vm.validateField('lastName')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.lastName)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.lastName)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.phoneNumber),expression:"userDetails.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text","id":"phoneNumberCS","placeholder":"254712345678","maxlength":"23","required":""},domProps:{"value":(_vm.userDetails.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "phoneNumber", $event.target.value)},function($event){return _vm.validateField('phoneNumber')}]}}),_vm._v(" "),(_vm.errors.phoneNumber)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.phoneNumber)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userDetails.email),expression:"userDetails.email",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"email","placeholder":"johndoe@email.cc","required":""},domProps:{"value":(_vm.userDetails.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "email", $event.target.value.trim())},function($event){return _vm.validateField('email')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.email)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.email)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.country),expression:"userDetails.country"}],staticClass:"form-control",attrs:{"type":"text","id":"countryCS","placeholder":"Country of residence","required":""},domProps:{"value":(_vm.userDetails.country)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "country", $event.target.value)},function($event){return _vm.validateField('country')}]}}),_vm._v(" "),(_vm.errors.country)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.country)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("City")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userDetails.city),expression:"userDetails.city",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"cityCS","placeholder":"City of residence","required":""},domProps:{"value":(_vm.userDetails.city)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "city", $event.target.value.trim())},function($event){return _vm.validateField('city')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.city)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.city)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.state),expression:"userDetails.state"}],staticClass:"form-control",attrs:{"type":"text","id":"stateCS","placeholder":"State of residence","required":""},domProps:{"value":(_vm.userDetails.state)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "state", $event.target.value)},function($event){return _vm.validateField('state')}]}}),_vm._v(" "),(_vm.errors.state)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.state)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('label',[_vm._v("Postal Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.userDetails.postalCode),expression:"userDetails.postalCode",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"postalCodeCS","placeholder":"Postal Code","required":""},domProps:{"value":(_vm.userDetails.postalCode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "postalCode", $event.target.value.trim())},function($event){return _vm.validateField('postalCode')}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.postalCode)?_c('p',{staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.errors.postalCode)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#"},on:{"click":function($event){return _vm.window.location.reload()}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.submitting)?_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.can_pay,"type":"button"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        Continue\n      ")]):_vm._e(),_vm._v(" "),(_vm.submitting)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("Please wait...")])]):_vm._e()])])])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-3ee196d9"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ee196d9", __vue__options__)
  } else {
    hotAPI.reload("data-v-3ee196d9", __vue__options__)
  }
})()}